import React from 'react';

interface PageWrapperProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'compact' | 'spacious';
}

const PageWrapper: React.FC<PageWrapperProps> = ({ 
  children, 
  className = '', 
  variant = 'default' 
}) => {
  const getPaddingClass = () => {
    switch (variant) {
      case 'compact':
        return 'p-2 sm:p-4 lg:p-6';
      case 'spacious':
        return 'p-6 sm:p-8 lg:p-12';
      default:
        return 'p-4 sm:p-6 lg:p-8';
    }
  };

  return (
    <div className={`${getPaddingClass()} ${className}`}>
      {children}
    </div>
  );
};

export default PageWrapper;
